


<div class="app-wrapper bg-white">
  <div class="mid-div row">
    <div class="col-12  d-flex ">
      <div class="login-background "></div>
      <div class="col-12 row" style="z-index: 200">
        <div class="col-7"></div>
        <div class="col-5" style="margin: auto">
          <h4 style="margin-left: 10px;" class="display-4 mb-2 font-weight-bold  color-black">
            Wellcome !
          </h4>
          <p class="para">We're glad you're glad crunching on your dashboard.
            Login in below to continue.</p>

          <div class="card-body padding-0" >
            <form [formGroup]="loginForm">
              <div class="form-group">

                <div class="d-flex justify-content-between mg-b-5">
                  <label>User Name</label>
                </div>

                <div class="input-group input-group-alternative">


                  <div class="input-group-prepend">
                                <span class="input-group-text">
                                  <i class="fa fa-user"></i>
                                </span>
                  </div>
                  <input formControlName="user"
                         class="form-control " placeholder="Enter your username" type="text">
                  <!--                              [ngClass]="{'is-invalid' : loginForm.get('username').hasError('required') && loginForm.get('username').touched }"-->

                </div>

              </div>


              <div class="form-group">

                <div class="d-flex justify-content-between mg-b-5">
                  <label>Password</label>
                </div>

                <div class="input-group">


                  <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <i class="fa fa-lock"></i>
                                </span>
                  </div>

                  <span class="password-input-span" (click)="toggleFieldTextType()" >
<!--                                  <fa-icon-->
                    <!--                                    [icon]="['fas', 'eye']"></fa-icon>-->
                              </span>

                  <span class="password-input-span" (click)="toggleFieldTextType()" >
<!--                                  <fa-icon-->
                    <!--                                    [icon]="['fas', 'eye-slash']"></fa-icon>-->
                              </span>

                  <input formControlName="password"
                         class="form-control password-padding" placeholder="Enter your password"
                         [type]="fieldTextType ? 'text' : 'password'">
                </div>

              </div>


              <div class="text-center mb-3">
                <button class="btn  btn-block btn-success ladda-button" data-style="slide-up"
                        [ladda]="isLoading" [disabled]="!loginForm.valid"  (click)="login()">
                  <span class="ladda-label"> Login </span>
                  <span class="ladda-spinner"></span>
                  <div class="ladda-progress" style="width: 0px;"></div>
                </button>

              </div>
              <div class="row mb-3">

                <div class="col-12">
                  <div class="or-image"></div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<notifier-container></notifier-container>
